module.exports = __webpack_public_path__ + "assets/arrow_down.e825b7ea.svg";